"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const Icon_1 = __importDefault(require("./Icon"));
function RevokedStackIcon(props) {
    return (react_1.default.createElement(Icon_1.default, Object.assign({}, props),
        react_1.default.createElement("path", { d: "M17.647,12.41,9.621,7.558a1.036,1.036,0,0,0-1.086,0L.507,12.413a1.046,1.046,0,0,0,.005,1.8l8.026,4.853a1.041,1.041,0,0,0,1.083,0l8.031-4.856a1.046,1.046,0,0,0-.005-1.8Zm-1.8.9L9.079,17.4,2.31,13.31,9.079,9.217Z" }),
        react_1.default.createElement("path", { d: "M.507,17.2l.977-.591,7.054,4.265a1.035,1.035,0,0,0,1.083,0l7.054-4.264.976.59a1.046,1.046,0,0,1,0,1.794L9.621,23.848a1.041,1.041,0,0,1-1.083,0L.508,18.993a1.046,1.046,0,0,1,0-1.794Z" }),
        react_1.default.createElement("polygon", { points: "15.29 7.508 18.048 4.75 15.29 1.992 16.492 0.79 19.25 3.548 22.008 0.79 23.21 1.992 20.452 4.75 23.21 7.508 22.008 8.709 19.25 5.952 16.492 8.709 15.29 7.508" })));
}
exports.default = RevokedStackIcon;
